import { shaderMaterial } from '@react-three/drei';
import type ReactThreeFiber from '@react-three/fiber';
import { ShaderMaterialProps } from '@react-three/fiber';
import type { Texture } from 'three';
import * as THREE from 'three';
import casePlaneFragment from './case-plane-fragment.glsl';
import casePlaneVertex from './case-plane-vertex.glsl';

const uniforms = {
  uTime: 0,
  uTexture: '' as unknown as Texture,
  uProgress: 0,
  uProgressOutro: 0,
  uPointSize: 2.0,
  uOpacity: 0,
  uLumaZ: -6,
  uColorOutro: new THREE.Color('yellow'),
  uNoiseFrequency: 0,
  uNoiseAmplitude: 0,
  uSlowMotion: 1,
};
export type UniformTypes = typeof uniforms;

export const CasePlaneMaterial = shaderMaterial(
  // Uniform
  uniforms,
  casePlaneVertex,
  casePlaneFragment
);

// Add Typescript definitions
declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      casePlaneMaterial: ReactThreeFiber.MaterialNode<
        InstanceType<typeof CasePlaneMaterial>,
        ShaderMaterialProps
      >;
    }
  }
}
